import React, { useState, useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import ServicesTable from './components/ServicesTable';
import toast from 'react-hot-toast';
import Loader from 'loaders/Loader';
import { createAPIEndPoint } from 'config/api/api';
import { logoutUser } from 'utils';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'utils';

const Services = () => {
  const navigate = useNavigate();
  const userData = getUserData();
  const clinic_id = userData?.clinic_id ?? null;
  const [servicesData, setServicesData] = useState([]);
  const [loading, setLoading] = useState(true);

  // const fetchServices = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await createAPIEndPoint(`services/get_all/${clinic_id}`).fetchAll();
  //     console.log('fetchServices ~ response:', response.data.services);
  //     setServicesData(response.data.services || []);
  //   } catch (err) {
  //     toast.error(err?.response?.data?.error || 'Error fetching services');
  //     if (err?.response?.data?.error?.includes('Bearer token')) {
  //       logoutUser(navigate);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchServices();
  // }, []);

  const fetchServices = async () => {
    setLoading(true);

    try {
      const response = await createAPIEndPoint(
        `services/get_all/${clinic_id}`,
      ).fetchAll();

      const services = response.data.services || [];

      const sortedServices = services.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      );

      console.log('Latest first:', sortedServices);

      setServicesData(sortedServices);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Error fetching services');

      if (err?.response?.data?.error?.includes('Bearer token')) {
        logoutUser(navigate);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
      {loading && <Loader />}
      <ServicesTable
        tableData={servicesData}
        loading={loading}
        fetchAgain={fetchServices}
      />
    </Box>
  );
};

export default Services;
